<mat-form-field class="dict-ofwcas">
  <mat-select [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)"
              [multiple]="multiple" [placeholder]="label">
    <mat-option>
      <ngx-mat-select-search [formControl]="ofwcaFilterCtrl" placeholderLabel="Nazwa, PESEL, RAU..."
                             noEntriesFoundLabel="Nie znaleziono OFWCA">
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let option of items" [value]="option.uuid">
      <ng-container *ngIf="minimalDisplay; else fullDisplay, ">
        {{option.firstName}} {{option.lastName}} (PESEL: {{option.pesel}})
      </ng-container>
      <ng-template #fullDisplay>
        {{option.firstName}} {{option.lastName}}
        <ng-container *ngIf="option.pesel">
          (PESEL: {{option.pesel}})
        </ng-container>
        <ng-container *ngIf="status">
          (Status: {{option.status?.name}})
        </ng-container>
        <ng-container *ngIf="option.facility?.address?.city">
          ({{option.facility?.address?.city}})
        </ng-container>
        <ng-container *ngIf="option.assetsRegional?.fullName">
          {{option.assetsRegional?.fullName}}
        </ng-container>
      </ng-template>
    </mat-option>

  </mat-select>
  <button *ngIf="((control.value !== null
  && multiple && control.value.hasOwnProperty('length')
  && control.value.length > 0) || (!multiple && control.value))
  && !required && !control.disabled"
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearValue(); $event.stopPropagation()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
  <mat-error *ngIf="control.hasError('backendError')">{{control.getError('backendError')}}</mat-error>
</mat-form-field>
